import { render, staticRenderFns } from "./AnchorPointCreator.vue?vue&type=template&id=87aaa59a&scoped=true&"
import script from "./AnchorPointCreator.vue?vue&type=script&lang=js&"
export * from "./AnchorPointCreator.vue?vue&type=script&lang=js&"
import style0 from "./AnchorPointCreator.vue?vue&type=style&index=0&id=87aaa59a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87aaa59a",
  null
  
)

export default component.exports